import { useCallback, useRef } from "react";

/**
 * Inclinação 3D suave seguindo o cursor.
 * O container precisa da classe `.tilt-scene`; o alvo, `.tilt-target`.
 */
export default function useTilt({ max = 9, scale = 1.02 } = {}) {
  const ref = useRef(null);
  const frame = useRef(null);

  const onMouseMove = useCallback(
    (event) => {
      const el = ref.current;
      if (!el) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      if (frame.current) cancelAnimationFrame(frame.current);

      const { clientX, clientY } = event;
      frame.current = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const px = (clientX - rect.left) / rect.width - 0.5;
        const py = (clientY - rect.top) / rect.height - 0.5;
        el.style.transition = "transform .12s linear";
        el.style.transform = `rotateY(${px * max * 2}deg) rotateX(${
          -py * max * 2
        }deg) scale(${scale})`;
      });
    },
    [max, scale]
  );

  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    if (frame.current) cancelAnimationFrame(frame.current);
    el.style.transition = "transform .7s cubic-bezier(.16,1,.3,1)";
    el.style.transform = "rotateY(0deg) rotateX(0deg) scale(1)";
  }, []);

  return { ref, onMouseMove, onMouseLeave };
}
